import { render, staticRenderFns } from "./CategoryPopup.vue?vue&type=template&id=7951877f&scoped=true"
import script from "./CategoryPopup.vue?vue&type=script&lang=js"
export * from "./CategoryPopup.vue?vue&type=script&lang=js"
import style0 from "./CategoryPopup.vue?vue&type=style&index=0&id=7951877f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951877f",
  null
  
)

export default component.exports